import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function TutorialProgress({ progress }) {
  const [minimized, setMinimized] = useState(false);
  const prefersReducedMotion = useReducedMotion();

  if (!progress || progress.total === 0) return null;

  return (
    <motion.div
      className="fixed bottom-4 right-4 z-[91]"
      initial={prefersReducedMotion ? {} : { opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      role="progressbar"
      aria-valuenow={progress.percentage}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Tutorial progress: step ${progress.current} of ${progress.total}`}
    >
      <button
        onClick={() => setMinimized(!minimized)}
        className={cn(
          'flex items-center gap-2 px-3 py-2 rounded-full shadow-lg border transition-colors',
          'bg-background/95 backdrop-blur-sm hover:bg-accent text-foreground text-xs font-medium'
        )}
      >
        <AnimatePresence mode="wait">
          {!minimized ? (
            <motion.span
              key="expanded"
              initial={prefersReducedMotion ? {} : { opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="flex items-center gap-2"
            >
              <span className="whitespace-nowrap">
                Step {progress.current} of {progress.total}
              </span>
              <div className="w-16 h-1.5 bg-muted rounded-full overflow-hidden">
                <motion.div
                  className="h-full bg-primary rounded-full"
                  initial={{ width: 0 }}
                  animate={{ width: `${progress.percentage}%` }}
                  transition={{ duration: 0.4 }}
                />
              </div>
              <ChevronDown className="w-3 h-3" />
            </motion.span>
          ) : (
            <motion.span
              key="minimized"
              initial={prefersReducedMotion ? {} : { opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="flex items-center gap-1"
            >
              <span>{progress.current}/{progress.total}</span>
              <ChevronUp className="w-3 h-3" />
            </motion.span>
          )}
        </AnimatePresence>
      </button>
    </motion.div>
  );
}
